import { Table } from "react-bootstrap"

const Warranty = () => {
    const questionnaire = [
        {
            number: "1",
            question:
                "Will be relied upon by Great American Insurance Companies in determining the acceptability of the prospective Insureds and the premium amount to be charged;"
        },
        {
            number: "2",
            question: "Are true, accurate and complete; and"
        },
        {
            number: "3",
            question: "Will be considered an integral part of any resultant insurance contract."
        }
    ]

    return (
        <div className="warranty">
            <div>
                The undersigned is an authorized representative of the prospective First Named Insured, and acknowledges
                that the information provided with the Application, including all supplements, attachments and replies
                to underwriter inquiries, and applications from other insurance companies which have been submitted to
                Great American and made a part of this application:
            </div>
            <br />
            <Table striped>
                <tbody>
                    {questionnaire.map((question, index) => (
                        <tr key={index}>
                            <td>{question.number}</td>
                            <td>{question.question}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div>
                The undersigned further agrees that the prospective Named Insured(s) has a continuing duty, through date
                of policy inception, to update this Application, including all supplements, attachments and replies to
                underwriter inquiries.
            </div>
            <br />
        </div>
    )
}

export default Warranty
